
export const STATUS_FILTERS = [
  { label: "All", value: "All" },
  { label: "Signed In", value: "In" },
  { label: "Signed Out", value: "Out" },
  { label: "Pending", value: "Pending" },
  { label: "Rejected", value: "Rejected" },
];
export const RememberStatusFilter = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Signed In",
    value: "In",
  },
  {
    label: "Signed Out",
    value: "Out",
  },
];